/**
 * positon 调位置的
 * [prop]: {
 *  styleValue:       // 嵌入c3变形等
 *  horizontal:        // 从左开始
 *  vertical          // 从上开始
 *  verticalPX        //像素平移
 *  horizontalPX       //像素平移
 * }
 */

export default {
  computed: {
    finallyStyle() {
      var styleBuilder = this.styleValue;
      if (this.horizontal) {
        styleBuilder += `left:${this.horizontalPX}px;`;
      } else {
        styleBuilder += `right:${this.horizontalPX}px;`;
      }

      if (this.vertical) {
        styleBuilder += `top:${this.verticalPX}px;`;
      } else {
        styleBuilder += `bottom:${this.verticalPX}px;`;
      }
      return styleBuilder;
    }
  },
  props: {
    styleValue: {
      type: [String],
      default: "",
      validator(e) {
        if ("" === e) {
          return true;
        }
        return /;$/.test(e)
      }
    },
    horizontal: {
      type: Boolean,
      default: true
    },
    vertical: {
      type: Boolean,
      default: true
    },
    verticalPX: {
      type: [Number, String],
      default: '0',
      validator: (e) => {
        return /^[0-9]{1,}$/.test(e)
      }
    },
    horizontalPX: {
      type: [Number, String],
      default: '0',
      validator: (e) => {
        return /^[0-9]{1,}$/.test(e)
      }
    }
  }
}